<div class="seg-em">
  @if (cargando && !fichas.length) {
    <div class="seg-em__vacio" role="status">
      <mat-icon>hourglass_top</mat-icon>
      <p>Buscando el seguimiento…</p>
    </div>
  } @else if (error && !fichas.length) {
    <div class="seg-em__vacio seg-em__vacio--error" role="alert">
      <mat-icon>error_outline</mat-icon>
      <p>No se pudo traer el seguimiento de la emergencia.</p>
    </div>
  } @else if (!fichas.length) {
    <div class="seg-em__vacio" role="status">
      <mat-icon>timeline</mat-icon>
      <p class="no-info">Sin movimientos registrados</p>
    </div>
  } @else {
    <p class="seg-em__pista">
      <mat-icon>info</mat-icon>
      <span>
        Lo más nuevo arriba. Los reportes seguidos del móvil "En tránsito" y
        "Rumbo a hospital" se juntan en un solo paso. Tocá un paso para ver el
        detalle.
      </span>
    </p>

    <ol class="seg-em__linea">
      @for (f of fichas; track f.evento._id; let primero = $first) {
        <li
          class="seg-em__paso"
          [class.seg-em__paso--actual]="primero"
          [class.seg-em__paso--final]="esFinal(f)"
          [style.--tono]="f.presentacion.color"
        >
          <button
            type="button"
            class="seg-em__ficha irx-sin-estilo"
            (click)="verDetalles(f)"
            [attr.aria-label]="'Ver el detalle de ' + f.presentacion.label"
          >
            <span class="seg-em__icono">
              <mat-icon>{{ f.presentacion.icono }}</mat-icon>
              @if (f.evento.totalEventos > 1) {
                <span class="seg-em__cuenta">
                  {{ f.evento.totalEventos }}
                </span>
              }
            </span>

            <span class="seg-em__cuerpo">
              <span class="seg-em__titulo">
                <span class="seg-em__chip">
                  {{ f.presentacion.label }}
                </span>
                @if (primero) {
                  <span class="seg-em__actual">Estado actual</span>
                }
              </span>
              @if (f.rango) {
                <span class="seg-em__rango">{{ f.rango }}</span>
              }
              @for (l of f.lineas; track $index) {
                <span class="seg-em__dato">
                  <mat-icon>{{ l.icono }}</mat-icon>
                  <span>{{ l.texto }}</span>
                </span>
              }
            </span>

            <span class="seg-em__cuando">
              <span class="seg-em__fecha">{{ f.fecha }}</span>
              <span class="seg-em__hace">{{ f.hace }}</span>
            </span>

            <mat-icon class="seg-em__ir">chevron_right</mat-icon>
          </button>
        </li>
      }
    </ol>
  }
</div>
